(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('invoice-payment', {
            // parent: 'entity',
            parent: 'app',
            url: '/invoice-payment?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.invoicePayment.home.title'
            },
            views: {
                // 'content@': {
                'invoice-payment@': {
                    templateUrl: 'app/entities/invoice-payment/invoice-payments.html',
                    controller: 'InvoicePaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoicePayment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-payment-detail', {
            // parent: 'entity',
            parent: 'app',
            // url: '/invoice-payment/{id}',
            url: '/invoice-payment/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.invoicePayment.detail.title'
            },
            views: {
                // 'content@': {
                'invoice-payment-detail@': {
                    templateUrl: 'app/entities/invoice-payment/invoice-payment-detail.html',
                    controller: 'InvoicePaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoicePayment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InvoicePayment', function($stateParams, InvoicePayment) {
                    return InvoicePayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-payment-detail.edit', {
            // parent: 'invoice-payment-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/invoice-payment/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-payment/invoice-payment-dialog.html',
                    controller: 'InvoicePaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePayment', function(InvoicePayment) {
                            return InvoicePayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-payment.new', {
            // parent: 'invoice-payment',
            parent: 'app',
            // url: '/new',
            url: '/invoice-payment/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-payment/invoice-payment-dialog.html',
                    controller: 'InvoicePaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                payDate: null,
                                payRef: null,
                                bank: null,
                                amount: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice-payment', null, { reload: true });
                }, function() {
                    $state.go('invoice-payment');
                });
            }]
        })
        .state('invoice-payment.edit', {
            // parent: 'invoice-payment',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/invoice-payment/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-payment/invoice-payment-dialog.html',
                    controller: 'InvoicePaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePayment', function(InvoicePayment) {
                            return InvoicePayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-payment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-payment.delete', {
            // parent: 'invoice-payment',
            parent: 'invoice-payment',
            // url: '/{id}/delete',
            url: '/invoice-payment/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-payment/invoice-payment-delete-dialog.html',
                    controller: 'InvoicePaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InvoicePayment', function(InvoicePayment) {
                            return InvoicePayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-payment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
